<template>
  <section>
    <v-card class="py-7" tile flat>
      <v-card-text>
        <v-alert border="left" type="info" dark outlined>
          All documents that are e-signed will require an audit trail.
        </v-alert>
        <vue-dropzone
          ref="submitPackageDropzone"
          id="submitPackageDropzone"
          :options="submitPackageDropzoneOptions"
          @vdropzone-file-added="vdropzoneFileAdded"
          @vdropzone-error-multiple="submitPackageVDropzoneErrorMultiple"
          @vdropzone-success-multiple="submitPackageVDropzoneSuccessMultiple"
          @vdropzone-complete-multiple="vdropzoneCompleteMultiple"
          @vdropzone-queue-complete="
            submitPackageVDropzoneQueueCompleteMultiple
          "
        ></vue-dropzone>
      </v-card-text>
      <v-card-actions class="text-center">
        <v-btn
          class="mx-auto"
          @click="submitFiles"
          color="info"
          min-width="200"
          elevation="0"
          :loading="submitting"
        >
          Upload File(s)
        </v-btn>
      </v-card-actions>
    </v-card>
  </section>
</template>

<script>
import vueDropzone from "vue2-dropzone";

export default {
  name: "UploadSubmissionFiles",
  props: {
    notify: Boolean,
  },
  data() {
    return {
      submitting: false,
      submitPackageDropzoneOptions: {
        acceptedFiles: "image/*,application/pdf,.html,.doc,.docx,.txt,.xml",
        url: `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/EmbeddedDoc/Dropzone`,
        headers: { Authorization: `Bearer ${this.$store.state.token}` },
        thumbnailWidth: 200,
        addRemoveLinks: true,
        maxFiles: 10,
        maxFilesize: 100, // 100 MB
        autoProcessQueue: false,
        uploadMultiple: true,
        paramName: () => "files",
        dictDefaultMessage:
          "<p class='text-h6'>Upload your Submission file(s)</p><p class='text-hsubtitle-1'>(You may upload up to 10 files)</p>",
      },
      uploadedEmbeddedDocs: [],
    };
  },
  components: {
    vueDropzone,
  },
  methods: {
    // getFileInfo(path){
    //   const fileName = path.split('\\').reverse()[0].split('.');
    //   return {
    //     name: fileName[0].split("____")[1],
    //     extension: fileName[1]
    //   };
    // },
    submitFiles() {
      if (this.$refs.submitPackageDropzone.getQueuedFiles().length > 0) {
        this.submitting = true;
        this.$refs.submitPackageDropzone.processQueue();
      }
    },
    async vdropzoneFileAdded(file) {
      console.log("run: vdropzoneFileAdded");
      if (file != null && file.size <= 0) {
        this.$refs.submitPackageDropzone.removeFile(file);
        this.$store.commit(
          "statusDialog/showErrorDialog",
          "A compressed file exists.🤐 <br />Please unzip and try again."
        );
      }
    },
    async vdropzoneCompleteMultiple(response) {
      console.log("run: vdropzoneCompleteMultiple");
      console.log(response);
    },
    async submitPackageVDropzoneErrorMultiple(files, message) {
      console.log("run: vdropzone-error-multiple");
      this.$store.commit("statusDialog/showErrorDialog", message);
      this.$refs.submitPackageDropzone.removeAllFiles();
      this.submitting = false;
    },
    async submitPackageVDropzoneSuccessMultiple(files, response) {
      console.log("run: vdropzone-success-multiple");
      const fileNameList = response;

      for (let i = 0; i < fileNameList.length; i++) {
        this.uploadedEmbeddedDocs.push({
          path: fileNameList[i],
        });
      }
    },
    async submitPackageVDropzoneQueueCompleteMultiple() {
      console.log("run: vdropzone-queue-complete");
      if (this.uploadedEmbeddedDocs && this.uploadedEmbeddedDocs.length > 0) {
        const ret = await this.addBrokerConditions(
          this.uploadedEmbeddedDocs,
          this.$route.query.loanNumber,
          this.notify
        ).catch((err) => err.response);

        if (ret.status === 200) {
          this.$store.commit(
            "statusDialog/showSuccessDialog",
            `${this.uploadedEmbeddedDocs.length} file(s) have been uploaded successfully.`
          );
        } else {
          this.$store.commit("statusDialog/showErrorDialog", ret.data);
        }

        this.$refs.submitPackageDropzone.removeAllFiles();
        this.uploadedEmbeddedDocs = [];
      }
      this.submitting = false;
    },
    async addBrokerConditions(embeddedDocs, loanNumber, notify) {
      const resp = await this.$store
        .dispatch("embeddeddoc/create", {
          embeddedDocs: embeddedDocs,
          loanNumber: loanNumber,
          notify: notify,
        })
        .then((resp) => resp)
        .catch((err) => err);

      return resp;
    },
  },
};
</script>
